module.exports = __webpack_public_path__ + "static/2-32cc87871c1b691877988987bb38da56.png";